export const COLLECT_AND_HOLD_STUDY_TYPE = 'COLLECT_AND_HOLD'

export const STUDY_TYPE_OPTIONS = [
  { value: 'Collect & Hold', label: 'Collect & Hold' },
  { value: 'Real-Time Reads', label: 'Real-Time Reads' },
  { value: 'Retrospective Reads', label: 'Retrospective Reads' },
]

export const READ_CRITERIA_OPTIONS = [
  { value: 'RECIST 1.1', label: 'RECIST 1.1' },
  { value: 'mRECIST', label: 'mRECIST' },
  { value: 'irRECIST', label: 'irRECIST' },
  { value: 'PCWG1', label: 'PCWG1' },
  { value: 'PCWG2', label: 'PCWG2' },
  { value: 'PCWG3', label: 'PCWG3' },
  { value: 'Lugano', label: 'Lugano' },
  { value: 'Cheson', label: 'Cheson' },
  { value: 'RANO', label: 'RANO' },
  { value: 'RAPNO', label: 'RAPNO' },
  { value: 'Owen', label: 'Owen' },
]

export const READ_TYPE_OPTIONS = [
  { value: '2 Primary Reviewers + 1 Adjudicator', label: '2 Primary Reviewers + 1 Adjudicator' },
  { value: '1 Primary Reviewer', label: '1 Primary Reviewer' },
  {
    value: '2 Primary Reviewers + 1 Adjudicator, Baseline - Majority Rule',
    label: '2 Primary Reviewers + 1 Adjudicator, Baseline - Majority Rule',
  },
  { value: 'Consensus Read', label: 'Consensus Read' },
  { value: 'Radiomics Read-Out', label: 'Radiomics Read-Out' },
]

export const ANATOMIES_OPTIONS = [
  { value: 'Abdomen', label: 'Abdomen' },
  { value: 'Adrenal gland', label: 'Adrenal gland' },
  { value: 'Anus', label: 'Anus' },
  { value: 'Appendix', label: 'Appendix' },
  { value: 'Back', label: 'Back' },
  { value: 'Biliary tract', label: 'Biliary tract' },
  { value: 'Blood vessel', label: 'Blood vessel' },
  { value: 'Bone', label: 'Bone' },
  { value: 'Brain', label: 'Brain' },
  { value: 'Breast', label: 'Breast' },
  { value: 'Bronchus', label: 'Bronchus' },
  { value: 'Chest', label: 'Chest' },
  { value: 'Colon', label: 'Colon' },
  { value: 'Duodenum', label: 'Duodenum' },
  { value: 'Ear', label: 'Ear' },
  { value: 'Esophagus', label: 'Esophagus' },
  { value: 'Extremities', label: 'Extremities' },
  { value: 'Eye', label: 'Eye' },
  { value: 'Face', label: 'Face' },
  { value: 'Female genitalia', label: 'Female genitalia' },
  { value: 'Gallbladder', label: 'Gallbladder' },
  { value: 'Glands - other', label: 'Glands - other' },
  { value: 'Head', label: 'Head' },
  { value: 'Heart', label: 'Heart' },
  { value: 'Joint', label: 'Joint' },
  { value: 'Kidney', label: 'Kidney' },
  { value: 'Lacrimal gland', label: 'Lacrimal gland' },
  { value: 'Large intestine', label: 'Large intestine' },
  { value: 'Larynx', label: 'Larynx' },
  { value: 'Liver', label: 'Liver' },
  { value: 'Lung', label: 'Lung' },
  { value: 'Lymph node', label: 'Lymph node' },
  { value: 'Male genitalia', label: 'Male genitalia' },
  { value: 'Mediastinum', label: 'Mediastinum' },
  { value: 'Meninx', label: 'Meninx' },
  { value: 'Muscle', label: 'Muscle' },
  { value: 'Neck', label: 'Neck' },
  { value: 'Nervous system', label: 'Nervous system' },
  { value: 'Nose', label: 'Nose' },
  { value: 'Orbit', label: 'Orbit' },
  { value: 'Other', label: 'Other' },
  { value: 'Pancreas', label: 'Pancreas' },
  { value: 'Paranasal sinus', label: 'Paranasal sinus' },
  { value: 'Parathyroid gland', label: 'Parathyroid gland' },
  { value: 'Pelvis', label: 'Pelvis' },
  { value: 'Pericardium', label: 'Pericardium' },
  { value: 'Peritoneum', label: 'Peritoneum' },
  { value: 'Pleura', label: 'Pleura' },
  { value: 'Prostate gland', label: 'Prostate gland' },
  { value: 'Rectum', label: 'Rectum' },
  { value: 'Salivary glands', label: 'Salivary glands' },
  { value: 'Skin', label: 'Skin' },
  { value: 'Small intestine', label: 'Small intestine' },
  { value: 'Spine', label: 'Spine' },
  { value: 'Spleen', label: 'Spleen' },
  { value: 'Stomach', label: 'Stomach' },
  { value: 'Tendons', label: 'Tendons' },
  { value: 'Thymus gland', label: 'Thymus gland' },
  { value: 'Thyroid gland', label: 'Thyroid gland' },
  { value: 'Ureter', label: 'Ureter' },
  { value: 'Urethra', label: 'Urethra' },
  { value: 'Urinary bladder', label: 'Urinary bladder' },
  { value: 'Uterine appendages', label: 'Uterine appendages' },
  { value: 'Uterus', label: 'Uterus' },
  { value: 'Vagina', label: 'Vagina' },
  { value: 'Venous sinus', label: 'Venous sinus' },
  { value: 'Ventricular system', label: 'Ventricular system' },
  { value: 'Whole Body', label: 'Whole Body' },
]

export const MODALITIES_OPTIONS = [
  { value: 'X-Ray', label: 'X-Ray' },
  { value: 'CT', label: 'CT' },
  { value: 'MRI', label: 'MRI' },
  { value: 'FDG PET', label: 'FDG PET' },
  { value: 'FDOPA PET', label: 'FDOPA PET' },
  { value: 'Bone Scan', label: 'Bone Scan' },
  { value: 'DW-MRI', label: 'DW-MRI' },
  { value: 'DXA', label: 'DXA' },
  { value: 'Gamma Camera Imaging', label: 'Gamma Camera Imaging' },
  { value: 'Ultrasound', label: 'Ultrasound' },
  { value: 'Digital Photography', label: 'Digital Photography' },
]

export const TYPES_OF_UPLOAD_OPTIONS = [{ value: 'JPEG', label: 'JPEG' }]

export const THERAPEUTIC_AREA_OPTIONS = [
  { value: 'Oncology', label: 'Oncology' },
  { value: 'Cardiovascular', label: 'Cardiovascular' },
  { value: 'Diagnostic Imaging', label: 'Diagnostic Imaging' },
  { value: 'Dermatology', label: 'Dermatology' },
  { value: 'Cell & Gene Therapy', label: 'Cell & Gene Therapy' },
  { value: 'Women Healthcare', label: 'Women Healthcare' },
]

export const PHASE_OPTIONS = [
  { value: 'I', label: 'I' },
  { value: 'II', label: 'II' },
  { value: 'III', label: 'III' },
  { value: 'IV', label: 'IV' },
  { value: 'I/II', label: 'I/II' },
  { value: 'II/III', label: 'II/III' },
  { value: 'NIS', label: 'NIS' },
]

export const MAX_SITES_NBR = 10
